import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LockKey, User as UserIcon } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!u.trim() || !p) { toast.error("Enter username and password"); return; }
    setBusy(true);
    try {
      await login(u.trim(), p);
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="login-page">
      <div className="w-full max-w-sm surface p-8 fade-up">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg" style={{ background: "var(--primary)" }}>
            <span className="font-display text-white text-2xl leading-none">L</span>
          </div>
          <div>
            <div className="font-display text-2xl leading-none text-slate-900">LaserForge</div>
            <div className="overline mt-1">Sign in to continue</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs text-slate-600">Username</Label>
            <div className="relative">
              <UserIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input data-testid="login-username" value={u} onChange={(e) => setU(e.target.value)} autoComplete="username" className="pl-9" />
            </div>
          </div>
          <div>
            <Label className="text-xs text-slate-600">Password</Label>
            <div className="relative">
              <LockKey size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input data-testid="login-password" type="password" value={p} onChange={(e) => setP(e.target.value)} autoComplete="current-password" className="pl-9" />
            </div>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
